<template>
    <div class="product-container">
      <h1>Настройки</h1>
      
    </div>
  </template>
  
  <script setup lang="ts">
  </script>
  
  <style scoped>
  .product-container {
    text-align: center;
    padding: 20px;
  }
  </style>
  